import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { Box, Container, CssBaseline } from "@mui/material";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { BreadCrumb } from './main/typescript/components/CoreComponents';
import { Navbar, AppWrapper, ContentWrapper, Footer, useTheme } from 'customer-portal-ui-component-library';
import { Bulletin } from './main/typescript/components/pages/Bulletin'
import { MoreDetails } from './main/typescript/components/ArticleComponents';

import logo from './main/resources/images/ISS-Logo.png';

function App() {
  const theme = useTheme();
  return (
    <AppWrapper>
      <ThemeProvider theme={theme}>
        <Navbar logo={logo} appName='Customer Bulletin' portalUrl='https://portal.interlinksoftware.com' communityUrl='https://community.interlinksoftware.com' docUrl='https://docs.interlinksoftware.com' authUrl='https://auth.interlinksoftware.com' authRealm='Interlink_Portal' />
        <ContentWrapper>
          <Container disableGutters maxWidth={false} sx={{maxWidth: "65%"}}>
            <Box sx={{my: 2}}>
              <Router basename="/customer-bulletin">
                <BreadCrumb />
                <Routes>
                  <Route path="/" element={<Bulletin />} />
                  <Route path=":id" element={<MoreDetails />} />
                </Routes>
              </Router>
            </Box>
          </Container>
        </ContentWrapper>
        <Footer copyrightYear='2024' />
        <CssBaseline />
      </ThemeProvider>
    </AppWrapper>
  );
}

export default App;